module.exports = {
  PENDING: 'pending',
  FAILED: 'failed',
  CONFIRMED: 'confirmed',
  ACTION_REQUIRED: 'action_required',
};
